import { render } from "./Tooltip.vue?vue&type=template&id=4079c142&scoped=true"
import script from "./Tooltip.vue?vue&type=script&lang=js"
export * from "./Tooltip.vue?vue&type=script&lang=js"

import "./Tooltip.vue?vue&type=style&index=0&id=4079c142&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4079c142"

export default script